<template>
  <div id="Vitals-form">
    <div class="col-md-12">
      <div class="row">
        <div class="col-12 text-center">
          <h5 class="text-primary">Select your device</h5>
        </div>
      </div>
      <div class="row" style="margin-top: 2em;justify-content: center;">
        <div class="col-md-6 col-lg-4" v-for="(device, index) in deviceProfile" :key="device.identifier" :id="device.identifier">
          <patient-vital-device-card :deviceforcard="device" :vitals="vitals.deviceData" :vital-index="index" ref="vitalComponents" v-if="device.communication.communicationMethod != 'NOTIFY'" :error-messages="errorMessages" :historic-vitals="historicVitals" :allowManualEntry="true" :allowRetrieval="IS_PATIENT" :shareButton="false" :uploadButton="true" @click.native="goToShowVitals(device)"></patient-vital-device-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import patientVitalDeviceCard from "../components/PatientVitalDeviceCard.vue";
import v8n from "v8n";
import { mapState } from "vuex";
import moment from "moment-timezone";

export default {
  name: "vitals",

  components: {
    patientVitalDeviceCard,
  },

  async mounted() {
    this.IS_PATIENT = this.user.roles.includes("patient");

    this.deviceProfile = await this.getDeviceProfile();
    this.deviceProfile.forEach((device) => {
      device.vitals.forEach((vital) => {
        this.$set(this.errorMessages, vital.identifier, []);
      });

      //After scanning vitals by OCR. Populate scanned vitals
      let scannedDevice = this.scannedDevices.find((sd) => {
        return sd.identifier == device.identifier;
      });

      if (scannedDevice) {
        device.vitals = scannedDevice.vitals;
      }
    });

    //Clear scanned vitals data after populating
    this.$store.commit("setState", {
      stateName: "scannedDevices",
      stateValue: [],
    });
  },

  data() {
    return {
      validatedVitalCount: 0,
      vitals: {
        deviceData: {},
      },
      errorMessages: {},
      historicVitals: null,
      IS_PATIENT: false,
    };
  },

  computed: {
    ...mapState({
      patient: "patient",
      scannedDevices: (state) => state.scannedDevices,
    }),
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },

    endpoint() {
      return this.$store.state.endpoint;
    },
    deviceProfile() {
      return this.$store.state.deviceProfile;
    }

  },

  methods: {
    async getDeviceProfile() {
      try {
        let deviceProfile = [];
        //get device profile from configurations
        let response = await this.$store.dispatch(
          "getConfigurationByEndpointId",
          {
            endpointId: this.endpoint._id,
            type: "deviceProfile",
          }
        );
        if (response && response.value) {
          deviceProfile = response.value;
        }

        this.$store.state.deviceProfile = deviceProfile;
        return this.$store.state.deviceProfile;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    goToShowVitals(device) {
      this.$store.commit("setState", {
        stateName: "selectedMedicalDevice",
        stateValue: device,
      });
      this.$store.commit("setState", {
        stateName: "selectedDeviceProfile",
        stateValue: this.deviceProfile,
      });
      this.$router.push("/showpatientvitals");
    },
  },

  beforeDestroy() {
    this.deviceProfile.forEach((device) => {
      device.vitals.forEach((vital) => {
        vital.value = "";
      });
    });
  },
};
</script>
